import React, { useContext } from 'react';
import EventEmitter from '../../../../../utils/util/eventEmitter';
import { ListId } from '../ListIdContextProvider';

let listId = 'noName';
const listIdEmitter = new (class extends EventEmitter<{
  newListId: string;
}> {})();

/**
 * Obtiene el nombre del listado de la vista actual.
 */
export function getCurrentListId() {
  return listId;
}

/**
 * Establece el nombre del listado de la vista actual.
 */
export function setCurrentListId(newListId: string) {
  listId = newListId;
  listIdEmitter.emit('newListId', newListId);
}

/**
 * Escucha los cambios introducidos por setCurrentListId de forma de obtenerlos
 * en tiempo real dentro de un componente.
 */
export default function useCurrentListId(defaultListId?: string) {
  const [currentListId, setListId] = React.useState<string>(
    defaultListId ?? listId,
  );

  React.useMemo(() => {
    if (defaultListId) setCurrentListId(defaultListId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    return void listIdEmitter.on('newListId', setListId);
  }, []);

  /**
   * El contexto de lista tiene precedencia sobre lo demás
   */
  const contextId = useContext(ListId);
  if (contextId !== undefined) {
    if (getCurrentListId() !== contextId) setCurrentListId(contextId);
    return contextId;
  }

  return currentListId;
}
